import { BaseModel } from '@/api/base-model'
import { TypeformFormAPI } from '@/api/backend-client'

export class TypeformResponseVariable extends BaseModel<TypeformResponseVariable> {
    protected collectionName = TypeformFormAPI.collectionName

    constructor(
        public key: string,
        public type: string,
        public text?: string,
        public number?: number,
        public value?: string|number|null,
    ) { super(null) }

    toRequestData(): any {
        return {
            key: this.key,
            type: this.type,
            text: this.text,
            number: this.number,
            value: this.value,
        }
    }

    static fromData(data: any): TypeformResponseVariable {
        if (data === null || typeof data === 'string' || data instanceof TypeformResponseVariable) {
            return data
        }

        return new TypeformResponseVariable(
            data.key,
            data.type,
            data.text,
            data.number,
            data.value,
        )
    }
}
